export const FOUR_FACTORS = ['efg', 'orr', 'ftr', 'tov'];
export const RATINGS = ['offense', 'defense', 'net'];

export const STAT_TYPE_FOUR_FACTORS = 'fourFactors';
export const STAT_TYPE_SCORING = 'scoring';
export const STAT_TYPE_BOXSCORE = 'boxscore';
export const STAT_TYPE_PROFILE = 'profile';

export const BOXSCORE_FIELDS = [
  'min',
  'fg',
  '3pt',
  'ft',
  'oreb',
  'dreb',
  'reb',
  'ast',
  'stl',
  'blk',
  'to',
  'pf',
  '+/-',
  'pts',
];
